export const FinancialManagementRouteMap = {
  FinancialManagement: 'financial-management',
  FinancialReconciliation: 'verifyBills',
  FinancialReimbursement: 'finance',
  FinancialStatistics: 'statistics',
}

const FinancialManagement = [
  {
    path: '/user',
    name: FinancialManagementRouteMap.FinancialReconciliation,
    title: '财务对账',
    redirect: '/user/verifyBills',
    meta: {
      title: '财务对账',
      active: ['verifyBills'],
      permission: 'user:financeVerifyBills',
      showSubiems: false,
    },
    children: [],
  },
  {
    path: '/finance',
    name: FinancialManagementRouteMap.FinancialReimbursement,
    meta: {
      title: '财务报销',
      active: ['verifyBills'],
      permission: 'finance:first:reimbursement',
      showSubiems: false,
    },
    children: [],
  },
  {
    path: '/statistics',
    name: FinancialManagementRouteMap.FinancialStatistics,
    meta: {
      title: '财务报销',
      active: ['verifyBills'],
      permission: 'statistics:root',
      showSubiems: false,
    },
    children: [],
  },
]

export default FinancialManagement
